<template>
  <div class="evaluation-management">
    <!-- <el-steps :active="active" finish-status="success" simple>
      <el-step title="验证学生信息"></el-step>
      <el-step title="填写评价表"></el-step>
    </el-steps> -->
    <!-- 验证学生信息 -->
    <!-- <informationVerification v-show="active === 0" @nextStep="nextStep" /> -->
    <!-- 填写评价表 -->
    <evaluationForm class="table-evaluation" v-show="active === 1" @submitData="submitData" :teacherTypeOptions="teacherTypeOptions" :studentForm="studentForm"
      :schoolInfo="schoolInfo" :isOpen="isOpen" :teacherEvaluationList="teacherEvaluationList" />
    <pagination v-show="active === 1" :total="parseInt(total)" :pageSize="parseInt(pageSize)"
      @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
  </div>
</template>

<script>
// import informationVerification from "./components/information-verification/informationVerification.vue";
import evaluationForm from "./components/evaluation-form/evaluationForm.vue";
export default {
  components: {
    // informationVerification,
    evaluationForm
  },
  data() {
    return {
      active: 1,
      total: 1, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      schoolInfo: {},
      studentForm: {}, // 学生信息
      teacherEvaluationList: [], // 指定学生老师评价列表
      teacherTypeOptions: [], // 教师类型
      isOpen: true, // 是否在可评价时间内
    }
  },
  created() {
    this.getSchoolDetails();
    this.getTeacherType();
  },
  methods: {
    // 获取教师类型
    getTeacherType() {
      this.get(`${this.$url.getDictType}/sc_question_teacher_type`).then((res) => {
        this.teacherTypeOptions = res.data;
      });
    },
    submitData(data) {
      // console.log("提交的数据==>", data);
      this.post(this.$url.insetTeacherEvaluationRecords, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg || '提交失败');
        this.$message.success('提交成功');
        this.active = 1;
        this.geTeacherEvaluationList();
      })
    },
    // nextStep(studentForm) {
    //   this.studentForm = studentForm;
    //   this.geTeacherEvaluationList();
    // },
    geTeacherEvaluationList() {
      let { gradeId, classId, studentName, studentNumber } = this.user;
      let { schoolYear, semester } = this.schoolInfo;
      let data = {
        schoolYear,
        semester,
        // gradeId,
        // classId,
        studentName,
        studentNumber,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      // console.log("data==>", data);
      this.get(this.$url.selectTeacherEvaluationRecords, data).then(res => {
        // console.log("查询指定学生的教师评价列表==>", res);
        if (res.code !== 200) return this.$message.error(res.msg || '未查找到该学生');
        if (res.total === 0) return this.$message.warning("暂无可评价教师");
        this.total = res.data.teacherEvaluation.total;
        this.teacherEvaluationList = res.data.teacherEvaluation.rows;
        this.isOpen = res.data.isOpen;
        this.active = 1;
      });
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        this.schoolInfo = res.data;
        this.geTeacherEvaluationList();
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.geTeacherEvaluationList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.geTeacherEvaluationList();
    },
  }
};
</script>

<style lang="scss" scoped>
@import "./evaluationManagement.scss";
</style>